import React ,{useState,useEffect} from 'react';
import { Handle } from 'reactflow';
import { FaTrash, FaPlus } from 'react-icons/fa'; 
import '../Node_Edge_Components.css';

const Icon = ({ id, data, }) => {
  const [nodeName, setNodeName] = useState(data.label);
    const[color, setColor] = useState(data.iconColor);
    const [svgContent, setSvgContent] = useState("");
    const [nodeColor, setNodeColor] = useState(data.color);
    const [nodeFontColor, setNodeFontColor] = useState(data.fontColor);
    const [nodeFontSize, setNodeFontSize] = useState(data.fontSize);
    const [nodeFontStyle, setNodeFontStyle] = useState(data.fontStyle);
    let size = 18;

    useEffect(() => {
      setNodeName(data.label);
      setColor(data.iconColor);
      fetch(data.imageSrc)
        .then(response => response.text())
        .then(svg => {
          const coloredSvg = svg.replace(/fill="[^"]*"/g, `fill="${color}"`);
          setSvgContent(`data:image/svg+xml;base64,${btoa(coloredSvg)}`);
        })
        .catch(error => console.error(error));
       
    }, [data.label, data.imageSrc,color, data.iconColor]);
     
    useEffect(() => {
      setNodeColor(data.color);
      setNodeFontColor(data.fontColor);
      setNodeFontSize(data.fontSize);  
      setNodeFontStyle(data.fontStyle);   
    }, [data.color, data.fontColor, data.fontSize ,data.fontStyle ]);

   
  return (
    <>  
  <div className='iconNode'>
 <div className='nodeContent iconLabel' style={{ backgroundColor: nodeColor }}>
<p style={{color:nodeFontColor,fontSize: nodeFontSize, fontStyle:nodeFontStyle}}>{nodeName}</p>
  </div>
<div className='icon' >
{svgContent && (
            <img
              src={svgContent}
              alt=''  
              height='90%'
              width='90%'
            />  
          )}
  </div>
<div className='nodeIcons'>
       <FaTrash
         onClick={() => data.onDelete(id)}
         style={{ cursor: 'pointer', color: 'grey' }}
         size={size}
       />
       <FaPlus
         onClick={() => data.onAdd(id,"icon")}
         style={{ cursor: 'pointer', marginLeft: '10px', color: 'green' }}
         size={size}
       />
     </div>
</div>
<Handle type="source" position="right" style={{ background:'#ff0072', marginRight:'-2px' }} />
     <Handle type="target" position="left" style={{ background:'#ff0072' }} />

   </>
    
  )
}

export default Icon